/**
 * Legal/disclosure copy for the About page. Formal Art. 13 text lives on
 * /privacy.html (SSOT: wen docs/legal/privacy-policy-wen-en.md).
 */
export const LEGAL_SECTIONS = [
  {
    title: "Testnet demo - no real value",
    body: "WEN runs on Dusk testnet only. DUSK spent, staked, or won here has no monetary value and cannot be withdrawn to mainnet. Nothing here is real-money gambling.",
  },
  {
    title: "Not financial advice",
    body: "Events and outcomes are user-created content. Prices reflect pool activity, not a recommendation. Nothing in this app is investment, financial, or legal advice.",
  },
  {
    title: "Questions or issues",
    body: "This is a testnet build. Email us with problems or questions.",
    href: "mailto:info@nocturne-standards.org",
    linkLabel: "info@nocturne-standards.org",
  },
];

/** Kit-styled link to the hosted Art. 13 page. */
export function privacyPolicyLink() {
  const a = document.createElement("a");
  a.className = "btn-secondary";
  a.href = "./privacy.html";
  a.textContent = "Privacy policy";
  return a;
}
